import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import jsonData from "../../../../current-survey-numeric.json"; // Ensure the path is correct

const engagementQuestions = [
  "MQ0190",
  "MQ0141",
  "MQ0343",
  "MQ0088",
  "MQ0090",
  "MQ0091",
  "MQ0086",
  "MQ0034",
  "MQ0041",
  "MQ0194",
  "MQ0321",
  "MQ0058",
  "MQ0056",
  "MQ0057",
  "MQ0038",
];

const Score02 = ({ filterCriteria }) => {
  const [averageScore, setAverageScore] = useState(0);

  useEffect(() => {
    // Filter the data based on the filter criteria
    const filteredData = jsonData.filter((item) => {
      return Object.keys(filterCriteria).every((key) => {
        const criteria = filterCriteria[key] || []; // Default to an empty array if undefined
        if (criteria.length === 0) {
          return true;
        }
        return criteria.includes(item[key]);
      });
    });

    // Calculate the overall direct average score, considering only scores within 1-5
    const totalScore = filteredData.reduce((acc, response) => {
      return (
        acc +
        engagementQuestions.reduce((sum, question) => {
          const score = parseFloat(response[question]);
          return sum + (score >= 1 && score <= 5 ? score : 0);
        }, 0)
      );
    }, 0);

    const validScoresCount = filteredData.reduce((acc, response) => {
      return (
        acc +
        engagementQuestions.reduce((count, question) => {
          const score = parseFloat(response[question]);
          return count + (score >= 1 && score <= 5 ? 1 : 0);
        }, 0)
      );
    }, 0);

    const overallAverage = validScoresCount
      ? (totalScore / validScoresCount).toFixed(2)
      : 0;

    setAverageScore(overallAverage);
  }, [filterCriteria]);

  // Handle resizing and maintain size
  useEffect(() => {
    // Function to fix chart dimensions
    const fixChartDimensions = () => {
      const charts = document.querySelectorAll('#score-02 .apexcharts-canvas');
      charts.forEach(chart => {
        chart.style.width = '100%';
        chart.style.height = '100%';
        chart.style.minHeight = '100%';
        chart.style.maxHeight = '100%';
        chart.style.position = 'relative';
        chart.style.overflow = 'hidden';
      });
    };

    // Fix on mount and window resize
    fixChartDimensions();
    window.addEventListener('resize', fixChartDimensions);
    
    // Run again after a short delay to ensure the chart has rendered
    const timeout = setTimeout(fixChartDimensions, 100);
    
    return () => {
      window.removeEventListener('resize', fixChartDimensions);
      clearTimeout(timeout);
    };
  }, []);

  // Fix dimensions when average score changes
  useEffect(() => {
    const fixChartDimensions = () => {
      const charts = document.querySelectorAll('#score-02 .apexcharts-canvas');
      charts.forEach(chart => {
        chart.style.width = '100%';
        chart.style.height = '100%';
      });
    };
    
    // Wait for chart to update with new data
    const timeout = setTimeout(fixChartDimensions, 100);
    return () => clearTimeout(timeout);
  }, [averageScore]);

  const scoreOptions2 = {
    series: [
      {
        name: "Work Context",
        data: [averageScore],
      },
    ],
    chart: {
      type: "bar",
      height: "100%",
      width: "100%",
      animations: {
        enabled: false // Disable animations
      },
      redrawOnWindowResize: false, // Prevent redrawing on window resize
      redrawOnParentResize: false, // Prevent redrawing on parent resize
      dynamicAnimation: {
        enabled: false
      },
      selection: {
        enabled: false
      },
      zoom: {
        enabled: false
      },
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "80%", // Slightly reduced from 100%
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "20px", // Fixed font size
        fontWeight: "bold",
        colors: ["#fff"],
      },
      formatter: function (val) {
        return val ? val.toFixed(2) : "0";
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val.toFixed(2);
        },
      },
    },
    xaxis: {
      categories: ["Work Context"],
      show: false,
      labels: {
        show: false,
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
    },
    yaxis: {
      show: true,
      labels: {
        show: false,
      },
      title: {
        text: "Work Context",
        rotate: -90,
        style: {
          color: "#6d6d6d",
          fontSize: "16px", // Fixed font size
          fontWeight: "bold",
        },
      },
      min: 0,
      max: 5, // Set fixed maximum value
    },
    fill: {
      opacity: 1,
      colors: ["#ff8c00"],
    },
    responsive: [], // Empty array to disable responsive configs
    maintainAspectRatio: false, // Don't maintain aspect ratio
  };

  return (
    <div 
      id="score-02" 
      style={{ 
        height: "100%", 
        width: "100%", 
        position: "relative",
        overflow: "hidden"
      }}
    >
      <Chart
        options={scoreOptions2}
        series={scoreOptions2.series}
        type="bar"
        height="100%"
        width="100%"
      />
    </div>
  );
};

export default Score02;